<template>
  <ul class="image-list" :class="[`col-${col}`]">
    <li v-for="(item, index) in images" :key="index" class="list-item" :style="{width: itemWidth}">
      <nio-image :src="item.src" @click="handleJump(item)"></nio-image>
    </li>
  </ul>
</template>

<script>
import Image from '@/components/ui/Image';

export default {
  components: {
    'nio-image': Image
  },
  props: {
    config: {
      type: Object,
      default: () => ({})
    },
    gap: {
      type: Number,
      default: 10
    }
  },
  computed: {
    images(){
      if (this.config.attrs && this.config.attrs.images){
        return this.config.attrs.images;
      }
      return [];
    },
    col(){
      return this.config.attrs.columns || 1;
    },
    itemWidth(){
      if (this.col === 1){
        return '100%';
      }
      return `calc((100vw - ${(this.col - 1) * this.gap}px) / ${this.col})`;
    }
  },
  methods:{
    handleJump(item){
      if (item.attrs && item.attrs.href){
        this.$emit('link-click', item.attrs.href, item);
      } else {
        this.$emit('image-click', item.src, item);
      }
    }
  }

};
</script>

<style lang="scss" scoped>
@import '../../../assets/scss/standard';

.image-list {
  width: 100vw;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;

  .list-item {
    margin-bottom: sizeTrans($space_10);
  }
}
</style>